<template>
    <div>
        <div class="main-content">
			<div class="container-fluid">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-10 col-xl-10">

						<!-- Header -->
						<div class="header mt-md-5">
							<div class="header-body">
								<div class="row align-items-center">
									<div class="col">
										<!-- Title -->
										<h1 class="header-title">
											Dashboard
										</h1>
									</div>
								</div> <!-- / .row -->
							</div>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dashboard',
        data() {
            return {

            }
        },
        metaInfo: {
            title: 'Dashboard'
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/Dashboard.vue